// legacy build polyfills Uint8Array.toHex/toBase64, which the modern build needs natively (Chrome 140+)
import { version } from 'pdfjs-dist/legacy/build/pdf.mjs'

import { EMPTY_STRING } from '../../constants/common'

// pdf_viewer.mjs reads `globalThis.pdfjsLib` at init, which only the core module
// above sets — the viewer enums are taken from here, never from the package
export {
  FindState,
  ScrollMode,
  SpreadMode,
} from 'pdfjs-dist/legacy/web/pdf_viewer.mjs'

export const PDF_VIEWER_ASSETS_URL = `/static/pdfjs/${version}/`

export const PDF_VIEWER_NARROW_SCREEN_BREAKPOINT = '(max-width: 800px)'

export const PdfViewerFitMode = {
  PageFit: 'page-fit',
  PageWidth: 'page-width',
}

export const PdfViewerTool = {
  Pan: 'pan',
  Search: 'search',
  Thumbnails: 'thumbnails',
  ViewControls: 'viewControls',
  Zoom: 'zoom',
}

export const PDF_VIEWER_ALL_TOOLS = Object.values(PdfViewerTool)

export const PDF_VIEWER_DEFAULT_OPEN_PANELS = [PdfViewerTool.Thumbnails]

export const PdfViewerEvent = {
  Find: 'find',
  PageChanging: 'pagechanging',
  PageRendered: 'pagerendered',
  PagesInit: 'pagesinit',
  ScaleChanging: 'scalechanging',
  UpdateFindControlState: 'updatefindcontrolstate',
  UpdateFindMatchesCount: 'updatefindmatchescount',
}

// one `find` event serves both a new query and stepping through the current one
export const PdfViewerFindType = {
  Again: 'again',
  New: EMPTY_STRING,
}
